export const FETCH_CONTENT_SERIES_REQUEST_INIT = 'FETCH_CONTENT_SERIES_REQUEST_INIT';
export const FETCH_CONTENT_SERIES_REQUEST_SUCCESS = 'FETCH_CONTENT_SERIES_REQUEST_SUCCESS';
export const FETCH_CONTENT_SERIES_REQUEST_ERROR = 'FETCH_CONTENT_SERIES_REQUEST_ERROR';
export const SET_SEASON_SELECTED = 'SET_SEASON_SELECTED';
export const CLEAR_SERIE_DATA = 'CLEAR_SERIE_DATA';
export const SHOW_VOD_TRANSACTIONS_MODAL = 'SHOW_VOD_TRANSACTIONS_MODAL';
export const HIDE_VOD_TRANSACTIONS_MODAL = 'HIDE_VOD_TRANSACTIONS_MODAL';
export const SHOW_MENU_SERIES = 'SHOW_MENU_SERIES';
export const HIDE_MENU_SERIES = 'HIDE_MENU_SERIES';
export const SHOW_VOD_ANONYMOUS_MODAL = 'SHOW_VOD_ANONYMOUS_MODAL';
export const SET_EPISODE_INFO = 'SET_EPISODE_INFO';
